import apiHandler from './apiHandler';

const { publicRequest, cleanRequest } = apiHandler;

function authCreate({ username, password }) {

  const details = { username, password };
  let formBody = [];
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const property in details) {

    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(details[property]);
    formBody.push(`${encodedKey}=${encodedValue}`);

  }
  formBody = formBody.join('&');
  return publicRequest('/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    formData: formBody,
  });

}

// eslint-disable-next-line no-shadow
function refresh(refresh) {

  return publicRequest(`/auth/refresh?refresh_token_raw=${refresh}`, {
    method: 'POST',
    headers: {
      Authorization: `bearer ${refresh}`,
    },
    // body: { refresh },
  });

}

function me() {

  return cleanRequest('/jwt/v1/auth/users/me', {
    reqAuth: true,
  });

}

function getAllUsers({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/auth/users?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    method,
    signal,
  });

}

function resetPassword(email) {

  return publicRequest(`/auth/users/${email}/password-recovery`, {
    method: 'POST',
  });

}

function resetPasswordConfirm(body) {

  return publicRequest('/auth/users/reset-password', {
    method: 'POST',
    body,
  });

}

// function createUser(body) {

//   const method = 'POST';
//   return publicRequest('/auth/users', {
//     reqAuth: true,
//     method,
//     body,
//   });

// }

// function groupsUser({ signal } = {}) {

//   return publicRequest('/auth/groups/get/', {
//     reqAuth: true,
//     signal,
//   });

// }

// function clients({ signal } = {}) {

//   return publicRequest('/client/list/', {
//     reqAuth: true,
//     signal,
//   });

// }

// function createClient({ signal, body } = {}) {

//   return publicRequest('/client/create/', {
//     reqAuth: true,
//     method: 'POST',
//     body,
//     signal,
//   });

// }

// function updateClient({ clientId, signal, body } = {}) {

//   return publicRequest(`/client/update/${clientId}/`, {
//     reqAuth: true,
//     method: 'PUT',
//     body,
//     signal,
//   });

// }

// function updateClientActiveStatus({ signal, body } = {}) {

//   return publicRequest('/client/change-state/', {
//     reqAuth: true,
//     method: 'POST',
//     body,
//     signal,
//   });

// }

// function usersByClient({ clientId, signal } = {}) {

//   if (!clientId) return;
//   const params = new URLSearchParams({
//     client_id: clientId,
//   });
//   // eslint-disable-next-line consistent-return
//   return publicRequest(`/client/get_users/${params}`, {
//     reqAuth: true,
//     signal,
//   });

// }

// function updateUserActiveState({ signal, body } = {}) {

//   return publicRequest('/client/change-user-state/', {
//     reqAuth: true,
//     method: 'POST',
//     body,
//     signal,
//   });

// }

function createUser({ body, signal } = {}) {

  return publicRequest('/auth/users', {
    reqAuth: true,
    method: 'POST',
    body,
    signal,
  });

}

function updateUser({ id, body, signal } = {}) {

  return publicRequest(`/auth/users/${id}`, {
    reqAuth: true,
    method: 'PATCH',
    body,
    signal,
  });

}

function imageProfileData({ signal, id, formData }) {

  const method = 'PATCH';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest(`/auth/users/image_profile/${id}`, {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function createUserAdmin({ body, signal } = {}) {

  return publicRequest('/auth/users/superadmin', {
    reqAuth: true,
    method: 'POST',
    body,
    signal,
  });

}

function deleteUserById({ id, signal } = {}) {

  return publicRequest(`/auth/users/${id}`, {
    reqAuth: true,
    method: 'DELETE',
    signal,
  });

}

function updateUserMe({ body, signal } = {}) {

  return publicRequest('/auth/users/me', {
    reqAuth: true,
    method: 'PATCH',
    body,
    signal,
  });

}

function getUserMe({ signal }) {

  return publicRequest('/auth/users/me', {
    reqAuth: true,
    method: 'GET',
    signal,
  });

}

function getUserId({ id, signal }) {

  return publicRequest(`/auth/users/${id}`, {
    reqAuth: true,
    method: 'GET',
    signal,
  });

}

// function updateUser({ userId, body, signal } = {}) {

//   const params = new URLSearchParams({ user_id: userId });
//   return publicRequest(`/client/user/update/?${params}`, {
//     reqAuth: true,
//     method: 'PUT',
//     body,
//     signal,
//   });

// }

// function postPatchClientProperties({ formData, signal } = {}) {

//   const propertiesId = formData.has('propertiesId') ? formData.get('propertiesId') : null;
//   const urlRequest = propertiesId ?
//   `/client/properties/${propertiesId}/` : '/client/properties/';
//   const method = propertiesId ? 'PATCH' : 'POST';

//   return publicRequest(urlRequest, {
//     reqAuth: true,
//     headers: {
//       'Content-Type': undefined,
//     },
//     method,
//     formData,
//     signal,
//   });

// }

// function getPropertiesById({ propertyId, signal } = {}) {

//   return publicRequest(`/client/properties/${propertyId}/`, {
//     reqAuth: true,
//     signal,
//   });

// }

// function deletePropertiesById({ propertyId, signal } = {}) {

//   return publicRequest(`/client/properties/${propertyId}/`, {
//     reqAuth: true,
//     method: 'DELETE',
//     signal,
//   });

// }

export default {
  authCreate,
  refresh,
  me,
  getAllUsers,
  resetPassword,
  resetPasswordConfirm,
  createUser,
  createUserAdmin,
  deleteUserById,
  updateUser,
  updateUserMe,
  getUserMe,
  imageProfileData,
  getUserId,
//   groupsUser,
//   clients,
//   usersByClient,
//   updateClientActiveStatus,
//   updateUserActiveState,
//   createClient,
//   updateClient,
//   updateUser,
//   createUser,
//   postPatchClientProperties,
//   getPropertiesById,
//   deletePropertiesById,
};
